import { render, staticRenderFns } from "./roleAdd.modal.vue?vue&type=template&id=72700d1e"
import script from "./roleAdd.modal.vue?vue&type=script&lang=js"
export * from "./roleAdd.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports